export enum LOAD_STATES {
  READY = 1,
  BUSY,
  ERROR,
}
